import type { SVGProps } from 'react';
const SvgArrowSmallLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M10 12 6.08 8.188A.27.27 0 0 1 6 8a.26.26 0 0 1 .08-.188L10 4"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgArrowSmallLeft;
